import React from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";

const About = () => (
  <CSSTransition in classNames="fade" timeout={500} appear={true}>
    <div className="longcopy">
      <h2 className="title">About Me</h2>

      <p className="emphasis">
        <span className="bold">
          I am a UX designer who focuses on in-browser applications and landing pages. 
        </span>{" "}
         I design as a freelancer, working with various small businesses and startups.  Sometimes I work with developers and sometimes I am the developer because I'm not afraid to pick up documentation and take a swing: you can see <a href='https://www.github.com/marissaconner/sousanne' target="_blank">my current project on Github.</a>
         </p>

      <p>
        <a href="/downloads/marissa-conner-resume.pdf">VIEW RESUME</a>
      </p>

      <p>
        My interest in UX is an extension of my passion for
        sequential art and an individual&rsquo;s experience with visual media over
        time. That is, I like comics and graphic novels and I found that the same elements that drew me towards
        sequential art also presented themselves in UX design in a way that is
        equally compelling: you&rsquo;re shaping the audience&rsquo;s experience through
        visual stimulus over time and using design cues such as contrast or hierarchy of size and placement to guide their eyes and invite their participation.
        </p>

      <p>
        I was born into a blurry world with rapidly deteriorating eyesight and
        while &ldquo;practically blind&rdquo; is a bizarre profile for a designer, I was nevertheless compelled to study and savor light, color
        and composition while my visual acuity lasted.  <a href='/artwork'>It&rsquo;s made me a hell of an artist!</a> Surgery has saved my
        vision and the overall experience has rendered visual design into a very personal passion for me.
      </p>

      <p>
        I am from Dripping Springs, Texas and I got my start in UX through graphic design: I worked with small businesses in central Texas and established an online presence for many of those who lacked so much as a website, playing the part of designer and developer. I later graduated from Texas A&M with a Bachelors of Science in Visual Studies (visual design, interaction design, and digital rendering).
      </p>
    </div>
  </CSSTransition>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/about.js